
<template>
    
        <mars-view class="regulations-prompt"><mars-view v-if="nativeAd.type" class="regulations-prompt-card"><online-consult-card :ad-type="nativeAd.type" :ad-url="nativeAd.url" page-form="regulations"></online-consult-card></mars-view><mars-view v-if="rules.length === 0" class="search-regulations empty-regulations"><mars-text class="search-regulations-prompt">未找到您要的答案请</mars-text><mars-text class="search-regulations-text" @click.native="searchRelatedRegulation">查询相关法规</mars-text><mars-text class="icon view-more"></mars-text></mars-view><bottom-prompt v-if="prompt" :data="prompt" :is-show-join-entrance="true" font-size="14" fr="sp-flfg-lshz-2"></bottom-prompt></mars-view>
    
</template>

<script>
import Prompt from "../../../components/common/prompt.vue";
import { ubcClickInit } from '../../../static/utils/ubcMethods.js';
import onlineConsultCard from "../../../components/common/onlineConsultCard.vue";
export default {
  props: {
    searchTitle: {
      type: Object,
      default() {
        return null;
      }
    },
    searchSource: {
      type: String,
      default() {
        return '';
      }
    },
    rules: {
      type: Array,
      default() {
        return [];
      }
    },
    regulations: {
      type: Array,
      default() {
        return [];
      }
    },
    prompt: {
      type: Array,
      default() {
        return [];
      }
    },
    nativeAd: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    'bottom-prompt': Prompt,
    'online-consult-card': onlineConsultCard
  },
  methods: {
    // 查询相关法规
    searchRelatedRegulation() {
      ubcClickInit({
        page: 'regulations',
        value: 'rregulations-searchrelaw-clk'
      });
      this.$emit('searchRelatedRegulation', true);
    }
  }
};
</script>

<style scoped>
.regulations-prompt {
  flex: 1;
  background: #f5f5f5;
  position: relative;
  height: 100%;
}
.regulations-prompt .search-regulations {
  background: #f5f5f5;
  padding: 14px 17px 10px 17px;
  color: #555;
  font-size: 16px;
}
.regulations-prompt .search-regulations .search-regulations-prompt {
  vertical-align: middle;
}
.regulations-prompt .search-regulations .search-regulations-text {
  color: #445fbb;
  vertical-align: middle;
}
.regulations-prompt .search-regulations .view-more {
  background: #fff;
  border-radius: 50%;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  display: inline-block;
  background: url('https://law-smartapp.cdn.bcebos.com/icon/icon-more.png');
  background-size: 100% 100%;
}
.regulations-prompt .empty-regulations {
  height: 16vw;
}
.regulations-prompt .regulations-prompt-card {
  padding: 0 17px;
  background: #fff;
  border-top: 10px solid #f5f5f5;
}

</style>
